export default "__VITE_ASSET__iQkNIDjs__"